import { Horizontal, LoadingAnimation, Vertical } from '@gravitate-js/excalibrr'
import * as React from 'react'

import { OrderFreightDrawer } from '../OrderFreightDetails/components/OrderFreightDrawer'
import { ActivitySection } from './components/ActivitySection'
import { AttentionItems } from './components/AttentionItems'
import { CustomerOverview } from './components/CustomerOverview'
import { InvoiceMetrics } from './components/InvoiceMetrics'
import { InvoiceThroughput } from './components/InvoiceThroughput'
import { MetricSummary } from './components/MetricSummary'
import { LaunchpadProvider, useLaunchpadContext } from './context'
import { Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'

/**
 * Main content component for the Launchpad
 */
function LaunchpadContent() {
  const { isLoading, costRevenue, drawerState, handleNavigate, closeDrawer } = useLaunchpadContext()

  if (isLoading) {
    return (
      <Vertical flex={1} verticalCenter horizontalCenter>
        <Spin indicator={<LoadingOutlined spin />} size='large' />
      </Vertical>
    )
  }

  return (
    <>
      <Vertical gap={8} height='100%'>
        <Horizontal gap={8} flex='0' style={{ overflow: 'visible' }}>
          <InvoiceThroughput />
          <MetricSummary />
        </Horizontal>
        <Horizontal flex={1} gap={8}>
          <Vertical flex={3} bg='default' border='all' borderRadius='6px'>
            <CustomerOverview />
          </Vertical>
          <Horizontal flex={5} gap={8}>
            <Vertical gap={8} flex={2}>
              <InvoiceMetrics />
              <AttentionItems />
            </Vertical>
            <ActivitySection />
          </Horizontal>
        </Horizontal>
      </Vertical>
      <OrderFreightDrawer
        costRevenue={costRevenue}
        open={drawerState.visible}
        onClose={closeDrawer}
        order={drawerState.orders[drawerState.currentIndex]}
        allOrders={drawerState.orders}
        currentIndex={drawerState.currentIndex}
        onNavigate={handleNavigate}
      />
    </>
  )
}

/**
 * Entry point component for the Launchpad that wraps content with the context provider
 */
export function Launchpad() {
  return (
    <LaunchpadProvider>
      <LaunchpadContent />
    </LaunchpadProvider>
  )
}
